import { TaskService } from '@/core/usecase';
import { ITaskGateway, PresenterFunc, TaskInput } from '@/core/interface';
import { Task } from '@/core/entity';
import { Fragment, UpdaterFunc } from '@/core/interface/common';

export class TaskController {
  private readonly service: TaskService;

  constructor(taskGw: ITaskGateway) {
    this.service = new TaskService(taskGw);
  }

  public assign(
    taskId: string,
    userId: string,
    presenter: PresenterFunc<Task | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    this.service.assignTask(taskId, userId, presenter, fragment, updater);
  }

  public create(
    country: string,
    date: string,
    presenter: PresenterFunc<Task[] | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    this.service.newTasks(country, date, presenter, fragment, updater);
  }

  public split(
    taskId: string,
    entryIds: string[],
    presenter: PresenterFunc<Task | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    this.service.splitTask(taskId, entryIds, presenter, fragment, updater);
  }

  public update(
    taskId: string,
    input: TaskInput,
    presenter: PresenterFunc<Task | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    this.service.updateTask(taskId, input, presenter, fragment, updater);
  }
}
